import { Grid } from "@mui/material";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { CardsStatics } from "src/Pages/components/CardsStatics";
import { FormatMoney } from "src/shared/Utils/FormatMoney";

import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FileOpenIcon from '@mui/icons-material/FileOpen';

export const CardsBalancesHome = () => {
  const { valuesCardsBalancesHome } = useMetricsContext();

  return (
    <Grid container spacing={2} sx={{ mb: "24px" }}>
      <Grid item md={3} xs={12}>
        <CardsStatics
          data={{
            name: "Total de Produção",
            value1: {
              value: `R$ ${FormatMoney(valuesCardsBalancesHome?.totalProducao || "0,00")} `,
              valueSub: `(${valuesCardsBalancesHome?.totalVidas || "0"} vidas)`
            },
            icon: <FileOpenIcon color="success" sx={{ fontSize: "20px" }} />,
          }}
          tooltip="Total de produção é a soma de todas as produções dos seus clientes / Vidas (Quantidade de vidas cadastradas)"
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <CardsStatics
          data={{
            name: "Lucro Total / Previsto / Total",
            value1: {
              value: `R$ ${Number(valuesCardsBalancesHome?.totalLucro) < 0 ? "-" : ""} ${FormatMoney(valuesCardsBalancesHome?.totalLucro || "0,00")} `,
              valueSub: `(${valuesCardsBalancesHome?.percentMargeLucro || "0"}%)`
            },
            icon: <AttachMoneyIcon color="success" sx={{ fontSize: "20px" }} />,
            value2: {
              value: `R$ ${Number(valuesCardsBalancesHome?.previsto?.totalLucro) < 0 ? "-" : ""} ${FormatMoney(valuesCardsBalancesHome?.previsto?.totalLucro || "0,00")}`,
              valueSub: `(${valuesCardsBalancesHome?.previsto?.percentMargeLucro || "0"}%)`
            },
          }}
          tooltip="Lucro total é a diferença entre o total de entradas e o total de pagamentos / Margem de lucro é a relação entre o total de entradas e o total de pagamentos"
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <CardsStatics
          data={{
            name: "Total de Entradas / Previsto",
            value1: {
              value: `R$ ${FormatMoney(valuesCardsBalancesHome?.totalEntradas || "0,00")}`,
            },
            icon: <CurrencyExchangeIcon color="success" sx={{ fontSize: "20px" }} />,
            value2: {
              value: `R$ ${FormatMoney(valuesCardsBalancesHome?.previsto?.totalEntradas || "0,00")}`,
            },
          }}
          tooltip="Total de entradas é a soma de todas as comissões recebidas"
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <CardsStatics
          data={{
            name: "Total de Pagamentos / Previsto",
            value1: {
              value: `R$ ${FormatMoney(valuesCardsBalancesHome?.totalPagamentos || "0,00")}`,
            },
            icon: <ExitToAppIcon color="warning" sx={{ fontSize: "20px" }} />,
            value2: {
              value: `R$ ${FormatMoney(valuesCardsBalancesHome?.previsto?.totalPagamentos || "0,00")}`,
            },
          }}
          tooltip="Total de pagamentos é a soma de todas as comissões pagas para (Corretor, Supervisor e Gerente)"
        />
      </Grid>
      {/* <Grid item md={3} xs={12}>
        <CardsStatics
          data={{
            name: "Mensalidade ativas",
            value: `R$ ${FormatMoney(valuesCardsBalancesHome?.totalMensalidade || "0,00")}`,
            icon: <RequestQuoteOutlinedIcon color="info" sx={{ fontSize: "20px" }} />,
          }}
          tooltip="Mensalidade ativas é a soma de todas as mensalidades dos seus clientes pagantes"
        />
      </Grid> */}
    </Grid>
  );
};
